import { Grid, Typography } from '@mui/material';
import { Surface } from '../../../components/primitives';
import ChartSection from '../shared/ChartSection';
export default function NewVsDeparting({ data }) {
    if (!data?.new_members || !data?.departing_members) return null;

    const groups = [
        { key: 'new_members', label: 'New Members (since 2022)', color: 'primary.light' },
        { key: 'departing_members', label: 'Departing Members', color: 'text.secondary' },
    ];

    return (
        <ChartSection id="new-departing" title="Do new members trade differently than departing ones?" subtitle="Comparing first-term members vs those leaving office">
            <Grid container spacing={2}>
                {groups.map(g => {
                    const d = data[g.key];
                    if (!d || d.members === 0) return null;
                    const ratio = d.sells > 0 ? (d.buys / d.sells).toFixed(2) : '∞';
                    return (
                        <Grid item xs={12} md={6} key={g.key}>
                            <Surface variant="subtle" padding={2.5}>
                                <Typography variant="body1" sx={{ color: g.color, fontWeight: 700, mb: 1.5 }}>{g.label}</Typography>
                                <Grid container spacing={1.5}>
                                    {[
                                        { label: 'Members', value: d.members },
                                        { label: 'Buys', value: d.buys.toLocaleString() },
                                        { label: 'Sells', value: d.sells.toLocaleString() },
                                        { label: 'Buy/Sell', value: ratio + 'x' },
                                    ].map((s, i) => (
                                        <Grid item xs={6} key={i}>
                                            <Typography variant="overline" sx={{ color: 'text.muted', display: 'block', lineHeight: 1 }}>{s.label}</Typography>
                                            <Typography sx={{ fontFamily: t => t.typography.fontFamilyMono, fontWeight: 600, color: 'text.primary' }}>{s.value}</Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Surface>
                        </Grid>
                    );
                })}
            </Grid>
        </ChartSection>
    );
}
